// utils/colorUtils.js

// Función para calcular la luminancia relativa de un color
const getLuminance = (color) => {
    const rgb = parseInt(color.slice(1), 16); // Convertir de hexadecimal a decimal
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = (rgb >> 0) & 0xff;
  
    const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
    return luminance;
  };
  
  // Función para determinar si se debe usar texto blanco o negro
  export const getTextColorForBackground = (backgroundColor) => {
    const luminance = getLuminance(backgroundColor);
    return luminance > 0.5 ? '#000000' : '#FFFFFF'; // Negro si es claro, blanco si es oscuro
  };
  
  // Función para aclarar un color
export const lightenColor = (color, percent) => {
    const num = parseInt(color.slice(1), 16);
    const amt = Math.round(2.55 * percent);
    const R = (num >> 16) + amt;
    const G = ((num >> 8) & 0x00FF) + amt;
    const B = (num & 0x0000FF) + amt;
  
    return `#${(
      0x1000000 +
      (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
      (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
      (B < 255 ? (B < 1 ? 0 : B) : 255)
    )
      .toString(16)
      .slice(1)
      .toUpperCase()}`;
  };